<div class="locationGridCell" *ngrxLet="viewModel$; let viewModel;">
  <div class="flex items-center">
    @if ((viewModel.translationLoading && viewModel.isFieldTranslatable) || viewModel.valueLoading) {
      <ngx-skeleton-loader class="w-full" [theme]="{ marginBottom: 0 }"/>
    } @else {
      <span [ngClass]="{ 'text-neutral-60': viewModel.isFieldBlacklisted }">{{ viewModel.value }}</span>
    }

    <!--  pushes below icon to the far right  -->
    @if (viewModel.isFieldTranslatable && viewModel.translationShown) {
      <div class="grow"></div>
    }

    @if (viewModel.translationShown &&
         viewModel.isFieldTranslatable &&
         !viewModel.translationLoading &&
         !viewModel.valueLoading) {
      <mat-icon
        class="text-neutral-60 ml-2 h-[16px] w-[16px]"
        svgIcon="translate"/>
    }
  </div>
</div>
